import React from 'react'
import { Container, Typography } from '@cleartrip/ct-design-components'

interface NewFareRulesLoaderProps {
    fareRulesTab: string[]
}

const NewFareRulesLoader: React.FC<NewFareRulesLoaderProps> = ({ fareRulesTab }) => {
    return (
        <Container className="px-6 pt-6">
            <Container className="br-12 ba-solid bc-line-500 o-hidden">
                {/* Header Section */}
                <Container className="py-3 px-4" backgroundColor="#F3F3F3">
                    <Typography variant="HM3">Loading fare rules...</Typography>
                </Container>
                
                {/* Loading Content */}
                {fareRulesTab.map((item, index) => (
                    <React.Fragment key={index}>
                        <Container className="flex">
                            <Container width="30%" className="pl-4 py-4">
                                <Typography variant="B2">{item}</Typography>
                            </Container>
                            <Container
                                width="70%"
                                className="pl-4 pb-4 pt-2"
                                borderLeft="1px solid #E6E6E6"
                            >
                                <Container className="flex flex-between flex-middle pt-2">
                                    <Typography variant="B2" color="subheading">
                                        Loading...
                                    </Typography>
                                </Container>
                            </Container>
                        </Container>
                    </React.Fragment>
                ))}
            </Container>
        </Container>
    )
}

export default NewFareRulesLoader
